import { ComponentProps, forwardRef } from 'react'
import { cn } from '../utils'
import { Input as InputShadcn } from '@bpinternal/ui-kit-next'

export const Input = forwardRef<HTMLInputElement, ComponentProps<'input'>>(({ className, ...props }, ref) => {
  return <InputShadcn type="text" ref={ref} {...props} className={cn('w-full', className)} />
})
Input.displayName = 'Input'
